// Content Protection - Disables right-click, dev tools shortcuts, text selection
// while keeping content accessible to search engine crawlers (Googlebot, etc.)

export const initContentProtection = () => {
  // Skip protection for search engine bots (allows SEO crawling)
  const userAgent = navigator.userAgent.toLowerCase();
  const isBot = /bot|crawl|slurp|spider|mediapartners|googlebot|bingbot|yandex|duckduck|baiduspider|facebook|twitter|linkedin/i.test(userAgent);
  
  if (isBot) {
    console.log('Bot detected - protection skipped for SEO');
    return;
  }

  // Disable right-click context menu
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });

  // Disable keyboard shortcuts
  document.addEventListener('keydown', (e) => {
    // F12 - Developer Tools
    if (e.key === 'F12' || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+Shift+I - Inspect Element
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+Shift+J - Console
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+Shift+C - Element Inspector
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+U - View Source
    if ((e.ctrlKey || e.metaKey) && (e.key === 'U' || e.key === 'u')) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+S - Save Page
    if ((e.ctrlKey || e.metaKey) && (e.key === 'S' || e.key === 's')) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+P - Print
    if ((e.ctrlKey || e.metaKey) && (e.key === 'P' || e.key === 'p')) {
      e.preventDefault();
      return false;
    }
  });

  // Disable text selection
  document.body.style.userSelect = 'none';
  document.body.style.webkitUserSelect = 'none';
  document.body.style.msUserSelect = 'none';
  document.body.style.mozUserSelect = 'none';

  // Disable drag and drop on images
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });

  // Disable copy event
  document.addEventListener('copy', (e) => {
    e.preventDefault();
    return false;
  });

  // Disable cut event
  document.addEventListener('cut', (e) => {
    e.preventDefault();
    return false;
  });

  // Basic DevTools detection
  const devToolsDetector = () => {
    const threshold = 160;
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    if (widthThreshold || heightThreshold) {
      console.clear();
    }
  };

  setInterval(devToolsDetector, 1000);
};
